import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
import {K2AssigneeSelectOption} from "@k2/common/k2-select/k2-assignee-select-option";


@Component({
    selector: 'k2-assignee-select',
    templateUrl: 'k2-assignee-select.component.html',
    styleUrls: ['k2-assignee-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class K2AssigneeSelectComponent implements OnChanges, OnDestroy {
  @Input() value: any;
  @Input() options: K2AssigneeSelectOption[];
  @Input() placeholder = 'Please select...';
  @Input() disabled = false;
  @Input() multiple = false;
  @Input() matSelectId?: string;

  @Output() valueChange = new EventEmitter<any>();
  @Output() openedChange = new EventEmitter<boolean>();
  filterCtrl: UntypedFormControl = new UntypedFormControl();
  filteredOptions: K2AssigneeSelectOption[];
  alive = false;

  constructor() {
    this.alive = true;
    this.filterCtrl.valueChanges.pipe(takeWhile(() => this.alive)).subscribe(val => {
      if (val) {
        this.filteredOptions = this.options.filter(({ text }) =>
          !text || text.toLowerCase().includes(val.toLowerCase())
        );
      } else {
        this.filteredOptions = this.options;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.options &&
      (!changes.options.previousValue ||
        changes.options.previousValue.length !== changes.options.currentValue.length)
    ) {
      this.filteredOptions = this.options;
    }
  }

  changeValue() {
    this.filterCtrl.patchValue(null);
    this.valueChange.emit(this.value);
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
